import { formatDiscount, formatPrice } from "@app/utils/product";
import { getGeniusLink } from "@app/utils/trackers/skimlinks";

type DealsSourceData = {
  name: string;
  url: string;
  original: string;
  discount: string;
  discountPrice: string;
  dynamicPricing?: string;
}[];

export type ExtractedAmazonData = {
  asin: string;
  discountPrice: number;
  originalPrice: number | undefined;
  discountPercentage: number | undefined;
};

export const maybeMergeAmazonData = (
  dealsSourceData: DealsSourceData,
  extractedAmazonData?: ExtractedAmazonData[],
) => {
  const mergedAmazonData = dealsSourceData.map((deal) => {
    const matchedAsinData =
      extractedAmazonData &&
      extractedAmazonData.find(
        (amazonData) => amazonData.asin === deal.dynamicPricing,
      );

    return {
      ...deal,
      ...(matchedAsinData && {
        original: formatPrice(matchedAsinData.originalPrice),
        discount: formatDiscount(
          matchedAsinData.discountPercentage,
        )?.toString(),
        discountPrice: formatPrice(matchedAsinData.discountPrice),
      }),
      url: getGeniusLink(deal.url),
    };
  });

  return mergedAmazonData;
};
